export enum StreakPrizeTypeEnum {
  NFT = 'NFT',

  SFT = 'SFT',

  POINTS = 'POINTS',


}
